import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface User {
    id: number;
    app: string;
    app_id: string;
    app_name: string;
    mobile_number: string;
    email: string | null;
    password: string | null;
    mpin: string | null;
    otp: string | null;
    first_name: string;
    last_name: string;
    full_name: string;
    referral_code: string | null;
    profile_picture: string | null;
    profile_picture_url: string | null;
    has_profile_picture: boolean;
    login_type: string;
    login_type_display: string;
    points: string;
    points_formatted: string;
    created_at: string;
    created_date: string;
    updated_at: string;
    updated_date: string;
    role: number;
    role_id: number;
    role_name: string;
    is_staff: boolean;
    is_superuser: boolean;
    is_active: boolean;
    is_blocked?: boolean;
    status_display: string;
    last_login: string | null;
    last_login_formatted: string | null;
    date_joined: string;
    days_since_created: number;
}

export interface UsersResponse {
    users: User[];
    total_count: number;
    filtered_count: number;
    filters_applied: {
        app_id: string | null;
        role_id: number | null;
        is_active: boolean | null;
        is_staff: boolean | null;
        is_superuser: boolean | null;
        login_type: string | null;
        min_points: number | null;
        max_points: number | null;
        search: string | null;
        order_by: string;
    };
}

interface UsersState {
    users: User[];
    totalCount: number;
    filteredCount: number;
    filtersApplied: any;
    loading: boolean;
    error: string | null;
    viewMode: 'list' | 'grid';
}

const initialState: UsersState = {
    users: [],
    totalCount: 0,
    filteredCount: 0,
    filtersApplied: {},
    loading: false,
    error: null,
    viewMode: 'list'
};

const usersSlice = createSlice({
    name: "users",
    initialState,
    reducers: {
        setUsers(state: UsersState, action: PayloadAction<UsersResponse>) {
            console.log('setUsers action dispatched:', action.payload);
            state.users = action.payload.users;
            state.totalCount = action.payload.total_count;
            state.filteredCount = action.payload.filtered_count;
            state.filtersApplied = action.payload.filters_applied;
            state.loading = false;
            state.error = null;
            console.log('New state after setUsers:', state);
        },
        setLoading(state: UsersState, action: PayloadAction<boolean>) {
            console.log('setLoading action dispatched:', action.payload);
            state.loading = action.payload;
        },
        setError(state: UsersState, action: PayloadAction<string>) {
            console.log('setError action dispatched:', action.payload);
            state.error = action.payload;
            state.loading = false;
        },
        setViewMode(state: UsersState, action: PayloadAction<'list' | 'grid'>) {
            console.log('setViewMode action dispatched:', action.payload);
            state.viewMode = action.payload;
            console.log('New viewMode:', state.viewMode);
        },
        clearUsers(state: UsersState) {
            console.log('clearUsers action dispatched');
            state.users = [];
            state.totalCount = 0;
            state.filteredCount = 0;
            state.filtersApplied = {};
            state.error = null;
        },
        testAction(state: UsersState) {
            console.log('testAction dispatched - testing store functionality');
            state.viewMode = state.viewMode === 'list' ? 'grid' : 'list';
        }
    },
});

export const { 
    setUsers, 
    setLoading, 
    setError, 
    setViewMode, 
    clearUsers,
    testAction
} = usersSlice.actions;

export default usersSlice.reducer;
